import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../api/client";
import { customDateFormatType2, customDateFormatType3, formatNumber } from "../utils/utils";
import { useState } from "react";
import { NumberOfPerPage } from "../utils/globalVariable";
const NUMBER_NFT_PER_PAGE = NumberOfPerPage.report;

const queryKey = "report";

async function fetchReport(
  currentPage,
  type,
  projectId,
  saleAreaId,
  saleBlockId,
  branchId,
  bookerId,
  startTime,
  endTime
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (type) {
      options.type = type;
    } else {
      options.type = 1;
    }
    if (projectId) options.projectId = projectId;
    if (saleAreaId) options.saleAreaId = saleAreaId;
    if (saleBlockId) options.saleBlockId = saleBlockId;
    if (branchId) options.branchId = branchId;
    if (bookerId) options.bookerId = bookerId;
    if (startTime) options.startTime = customDateFormatType3(startTime);
    if (endTime) options.endTime = customDateFormatType3(endTime);

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/locking/report?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const newData = data?.items.map((item, index) => {

      return {
        code:
          Number(type) === 2
            ? item?.saleAreaCode || "-"
            : (Number(type) === 3 ? item?.saleBlockCode || "-" : item?.code || "-"),
        name:
          Number(type) === 2
            ? item?.saleAreaName || "-"
            : (Number(type) === 3 ? item?.saleBlockName || "-" : item?.name || "-"),
        // jobTitleName: item?.jobTitleName || "-",
        saleAreaCode: item?.saleAreaCode || "-",
        saleAreaName: item?.saleAreaName || "-",
        saleBlockCode: item?.saleBlockCode || "-",
        saleBlockName: item?.saleBlockName || "-",
        totalBooking: item?.totalBooking || "0",
        totalBookingApproved: item?.totalBookingApproved || "0",
        totalLocking: item?.totalLocking || "0",
        totalLockingApproved: item?.totalLockingApproved || "0",
        
        totalLockingApartmentValueApproved: item?.totalLockingApartmentValueApproved
          ? `${formatNumber(item?.totalLockingApartmentValueApproved)} VNĐ`
          : "0 VNĐ",

        totalTtkq: item?.totalTtkq || "0",
        totalTtkqApproved: item?.totalTtkqApproved || "0",
        totalContract: item?.totalContract || "0",
        totalContractApproved: item?.totalContractApproved || "0",

        // totalBookingAmount: item?.totalBookingAmount
        //   ? `${formatNumber(item?.totalBookingAmount)} VNĐ`
        //   : "0 VNĐ",
        // totalBookingAmountApproved: item?.totalBookingAmountApproved
        //   ? `${formatNumber(item?.totalBookingAmountApproved)} VNĐ`
        //   : "0 VNĐ",
        // totalLockingAmount: item?.totalLockingAmount
        //   ? `${formatNumber(item?.totalLockingAmount)} VNĐ`
        //   : "0 VNĐ",
        // totalLockingAmountApproved: item?.totalLockingAmountApproved
        //   ? `${formatNumber(item?.totalLockingAmountApproved)} VNĐ`
        //   : "0 VNĐ",

        // totalTtkqAmount: item?.totalTtkqAmount
        //   ? `${formatNumber(item?.totalTtkqAmount)} VNĐ`
        //   : "0 VNĐ",
        // totalTtkqAmountApproved: item?.totalTtkqAmountApproved
        //   ? `${formatNumber(item?.totalTtkqAmountApproved)} VNĐ`
        //   : "0 VNĐ",

        // totalContractAmount: item?.totalContractAmount
        //   ? `${formatNumber(item?.totalContractAmount)} VNĐ`
        //   : "0 VNĐ",
        // totalContractAmountApproved: item?.totalContractAmountApproved
        //   ? `${formatNumber(item?.totalContractAmountApproved)} VNĐ`
        //   : "0 VNĐ",
        
        id: item?._id || '',
        saleBlockId: item?.saleBlockId || '',
        saleAreaId: item?.saleAreaId || '',
      };
    });

    return {
      data: newData,
      totals: data?.totals,
      totalPages,
      entries,
      startEntry,
      endEntry,
    };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useReport(
  type,
  projectId,
  saleAreaId,
  saleBlockId,
  branchId,
  bookerId,
  startTime,
  endTime
) {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      queryKey,
      currentPage,
      type,
      projectId,
      saleAreaId,
      saleBlockId,
      branchId,
      bookerId,
      startTime,
      endTime,
    ],
    queryFn: () =>
      fetchReport(
        currentPage,
        type,
        projectId,
        saleAreaId,
        saleBlockId,
        branchId,
        bookerId,
        startTime,
        endTime
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    reportData: data?.data,
    getTotalReportData: data?.totals,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
